// extracted by mini-css-extract-plugin
module.exports = {"options":"HeaderConnectionMenu_options__2Ykip","option":"HeaderConnectionMenu_option__2OJ24","btn":"HeaderConnectionMenu_btn__23SRL","icon":"HeaderConnectionMenu_icon__38pjW"};